module.exports = __webpack_public_path__ + "img/close-one.96579a28.png";